export default __webpack_public_path__ + "static/media/MLB.5ea6be61.png";